import type { IntegrationPayload } from "@/types/experience";

export default class Integration {
  // Copied from the payload by Object.assign.
  declare id: IntegrationPayload["id"];
  declare type: IntegrationPayload["type"];
  declare parameters: IntegrationPayload["parameters"];

  constructor(applicationData: IntegrationPayload) {
    Object.assign(this, applicationData);
  }

  getParameter(index: number, dflt?: unknown): unknown {
    if (this.parameters && this.parameters.length > index) {
      return this.parameters[index];
    }

    return dflt;
  }
}
